export enum USER_PICK_ORDER_TYPE {
  /**
   * 추천순 (기본)
   * 1. S멤버십 유저의 분석글 작성 시간 기준 내림 정렬
   * 2. S멤버십 아닌 유저의 분석글 작성 시간 기준 내림 차순
   */
  RECOMMEND,
  /**
   * 최신순 : 작성시간 내림차순 정렬
   */
  NEWEST,
  /**
   * 좋아요순
   * 1. 좋아요 수 내림차순 정렬
   * 2. 좋아요 수 같은 경우 작성 시간 기준 내림차순 정렬
   */
  LIKED
}

export enum USER_PICK_REWARD_TYPE {
  USER_PICK,
  TODAY_USER_PICK,
  S_MEMBER,
  USER_PICK_DASHBOARD,
  USER_PICK_WELCOME,
}

export enum USER_PICK_SPECIFIC_TYPE {
  /**
   * 전체 분석글
   */
  TOTAL,
  /**
   * 적중된 분석글 전체
   */
  HIT_PICK,
  /**
   * 오늘의 승부사 선정 분석글 전체
   */
  BEST_PICK,
}

/**
 * 나도 승부사 분석글 평가 등급
 *
 * 자동 등급시 아래와 같이 평가.
 * 수동으로 등급 조정도 가능.
 *
 * 500자 이상 S
 * 200이상 ~ 500 미만 A
 * 200미만 B
 */
export enum USER_PICK_GRADE {
  S_GRADE, A_GRADE, B_GRADE,
}

export enum USER_PICK_USER_GRADE {
  NEWBIE, // 뉴비(첫 분석글을 작성한 유저로 작성일 기준 3일까지 뉴비로 취급) - 시스템 자동 지정
  NORMAL, // 일반 (뉴비 기준일이 지나면 부여되는 일반 등급) - 시스템 자동 지정
  PROSPECTIVE, // 가망 (분석글의 질은 떨어지나 'Candid' 등급으로 변할 가망이 있는 유저) - 관리자 직접 지정
  CANDID, // 진솔한 (나도승부사 활동이 꾸준하고 나름 양질의 분석글을 작헝하는 유저) - 관리자 직접 지정
  NAMED, // 네임드 (퀄리티 있는 분석글을 작성하며, 유저들에게 인지도와 영향력이 있는 유저) - 관리자 직접 지정
  WORKER, // 작업 (내부에서 작업하는 계정) - 관리자 직접 지정
}
